export function updateSlickSlideFocusability(root: HTMLElement | null) {
  if (!root) return;

  root.querySelectorAll<HTMLElement>(`.slick-slide`).forEach((slide) => {
    const isHidden = slide.getAttribute(`aria-hidden`) === `true`;

    slide.querySelectorAll<HTMLElement>(`a, button, input, select, textarea, [tabindex]`).forEach((element) => {
      if (isHidden) {
        if (element.dataset.originalTabIndex === undefined) {
          element.dataset.originalTabIndex = element.getAttribute(`tabindex`) || ``;
        }

        element.setAttribute(`tabindex`, `-1`);
        return;
      }

      if (element.dataset.originalTabIndex !== undefined) {
        const originalTabIndex = element.dataset.originalTabIndex;

        if (originalTabIndex) {
          element.setAttribute(`tabindex`, originalTabIndex);
        } else {
          element.removeAttribute(`tabindex`);
        }

        delete element.dataset.originalTabIndex;
      }
    });
  });
}
